<!-- Spinner -->

<!-- Content -->
@if ((slideViewerFacade.currentSelectedSlidePage$ | async); as page ) {
  @if (page) {
    @if ((menuSharedFacade.showPrint$ | async) === false) {
      <medsurf-slide-header [page]="page"></medsurf-slide-header>
      <div class="w-100 h-100"
        [@routeAnimations]="position">
        <!--<router-outlet></router-outlet>-->
        <medsurf-slide-main></medsurf-slide-main>
      </div>
      <medsurf-slide-footer></medsurf-slide-footer>
    }
    @if ((menuSharedFacade.showPrint$ | async)) {
      <medsurf-print></medsurf-print>
    }
  } @else {
    <div class="d-flex justify-content-center m-2">
      <div class="spinner-border"></div>
    </div>
  }
}
